"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TRANSLATION = exports.SEAT_LOGO_URL = exports.MEALS_LOGO_URL = exports.INSURANCE_LOGO_URL = exports.IMAGE_TYPE = exports.ICON_TYPE = exports.FASTPASS_LOGO_URL = exports.DIMENSIONS = exports.BAGGAGE_LOGO_URL = void 0;
var _default = {
  MEAL: 'meal',
  BAGGAGE: 'baggage',
  SEAT: 'seat',
  INSURANCE: 'insurance',
  FASTPASS: 'fastpass'
};
exports.default = _default;
var TRANSLATION = {
  meal: 'meal',
  baggage: 'baggage',
  seat: 'seat',
  fastpass: 'fastpass',
  insurance: 'insurance',
  addMeal: 'Pre-book meal',
  addBaggage: 'Add baggage',
  addSeat: 'Pick a seat',
  addInsurance: 'Add insurance',
  addFastPass: 'Add fastpass'
};
exports.TRANSLATION = TRANSLATION;
var DIMENSIONS = {
  desktop: {
    width: '178px',
    height: '135px'
  },
  mobile: {
    width: '156px',
    height: '135px'
  }
};
exports.DIMENSIONS = DIMENSIONS;
var ICON_TYPE = {
  normal: {
    height: '40px',
    width: '40px'
  }
};
exports.ICON_TYPE = ICON_TYPE;
var IMAGE_TYPE = {
  meal: {
    height: '40px',
    width: '40px',
    src: 'https://static.airasia.com/design/images/flight/meal.svg',
    alt: 'Seat icon'
  },
  baggage: {
    height: '40px',
    width: '40px',
    src: 'https://a.staticaa.com/images/misc/baggage.svg',
    alt: 'Seat icon'
  },
  seat: {
    height: '40px',
    width: '40px',
    src: 'https://static.airasia.com/design/images/flight/seat.svg',
    alt: 'Seat icon'
  },
  fastpass: {
    height: '40px',
    width: '40px',
    src: 'https://storage.googleapis.com/static.airasia.com/design/images/flight/FastPass%20(1).svg',
    alt: 'Fastpass icon'
  },
  insurance: {
    height: '40px',
    width: '40px',
    src: 'https://static.airasia.com/design/images/flight/insurance.svg',
    alt: 'Seat icon'
  }
};
exports.IMAGE_TYPE = IMAGE_TYPE;
var MEALS_LOGO_URL = 'https://static.airasia.com/design/images/flight/meal.svg';
exports.MEALS_LOGO_URL = MEALS_LOGO_URL;
var BAGGAGE_LOGO_URL = 'https://a.staticaa.com/images/misc/baggage.svg';
exports.BAGGAGE_LOGO_URL = BAGGAGE_LOGO_URL;
var SEAT_LOGO_URL = 'https://static.airasia.com/design/images/flight/seat.svg';
exports.SEAT_LOGO_URL = SEAT_LOGO_URL;
var INSURANCE_LOGO_URL = 'https://static.airasia.com/design/images/flight/insurance.svg';
exports.INSURANCE_LOGO_URL = INSURANCE_LOGO_URL;
var FASTPASS_LOGO_URL = 'https://storage.googleapis.com/static.airasia.com/design/images/flight/FastPass%20(1).svg';
exports.FASTPASS_LOGO_URL = FASTPASS_LOGO_URL;